document.addEventListener('click', function(e){
  const thumb = e.target.closest('[data-product-thumb]');
  if(!thumb) return;
  const main = document.querySelector('[data-main-product-image]');
  if(main){ main.src = thumb.dataset.full || thumb.src; }
});


document.addEventListener('click', function(e){
  const btn = e.target.closest('[data-ftg-magazine]');
  if(!btn) return;
  const rail = document.querySelector(btn.dataset.ftgMagazine);
  if(!rail) return;
  const dir = btn.dataset.direction === 'next' ? 1 : -1;
  rail.scrollBy({left: dir * Math.max(360, rail.clientWidth * 0.86), behavior:'smooth'});
});


document.addEventListener('click', function(e){
  const btn = e.target.closest('[data-ftg-flipbook]');
  if(!btn) return;
  const rail = document.querySelector(btn.dataset.ftgFlipbook);
  if(!rail) return;
  const dir = btn.dataset.direction === 'next' ? 1 : -1;
  const page = rail.querySelector('.ftg-page-spread');
  const amount = page ? page.getBoundingClientRect().width + 38 : rail.clientWidth * 0.9;
  rail.scrollBy({left: dir * amount, behavior:'smooth'});
});


document.addEventListener('click', function(e){
  const open = e.target.closest('[data-ftg-open-story]');
  if(open){
    e.preventDefault();
    const modal = document.getElementById('ftg-story-modal');
    if(modal){ modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); }
  }
  const close = e.target.closest('[data-ftg-close-story]');
  if(close){
    const modal = document.getElementById('ftg-story-modal');
    if(modal){ modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); }
  }
  const btn = e.target.closest('[data-ftg-flipbook]');
  if(btn){
    const rail = document.querySelector(btn.dataset.ftgFlipbook);
    if(!rail) return;
    const dir = btn.dataset.direction === 'next' ? 1 : -1;
    const page = rail.querySelector('.ftg-page-spread');
    const amount = page ? page.getBoundingClientRect().width + 38 : rail.clientWidth * 0.9;
    rail.scrollBy({left: dir * amount, behavior:'smooth'});
  }
});
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){
    const modal = document.getElementById('ftg-story-modal');
    if(modal){ modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); }
  }
});

/* === FTG HOMEPAGE FILTERING, SORTING + COLOR THEME === */
(function(){
  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    var root = document.documentElement;
    var toggle = document.querySelector('[data-ftg-theme-toggle]');

    function setTheme(theme){
      root.setAttribute('data-theme', theme);
      if(toggle){
        var light = theme === 'light';
        toggle.setAttribute('aria-pressed', String(light));
        toggle.setAttribute('aria-label', light ? 'Switch to dark view' : 'Switch to light view');
        var icon = toggle.querySelector('.theme-toggle-icon');
        var label = toggle.querySelector('.theme-toggle-label');
        if(icon) icon.textContent = light ? '☾' : '☀';
        if(label) label.textContent = light ? 'Dark' : 'Light';
      }
    }

    setTheme(root.getAttribute('data-theme') || 'dark');
    if(toggle){
      toggle.addEventListener('click', function(){
        var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
        setTheme(next);
        try{ localStorage.setItem('ftgColorTheme', next); }catch(e){}
      });
    }

    document.querySelectorAll('[data-ftg-product-browser]').forEach(function(browser){
      var grid = browser.querySelector('[data-ftg-product-grid]');
      var tabs = browser.querySelector('[data-ftg-brand-tabs]');
      var sort = browser.querySelector('[data-ftg-product-sort]');
      var search = browser.querySelector('[data-ftg-product-search]');
      var searchClear = browser.querySelector('[data-ftg-product-search-clear]');
      var searchStatus = browser.querySelector('[data-ftg-search-status]');
      var empty = browser.querySelector('[data-ftg-no-results]');
      var sizeControl = browser.querySelector('[data-ftg-card-size-control]');
      var sizeSlider = browser.querySelector('[data-ftg-card-size-slider]');
      var sizeDown = browser.querySelector('[data-ftg-card-size-down]');
      var sizeUp = browser.querySelector('[data-ftg-card-size-up]');
      var sizeValue = browser.querySelector('[data-ftg-card-size-value]');
      var sectionTitle = browser.querySelector('#ftg-in-stock-watches');
      var categoryIntro = browser.querySelector('[data-ftg-category-intro]');
      if(!grid || !tabs || !sort) return;

      // Eleven customer-selectable card sizes. The storefront opens at 9 / 11
      // (185px), while shoppers can still choose any of the eleven levels.
      // V3 storage intentionally starts existing shoppers at the new default once,
      // while continuing to remember any size they choose afterward.
      var cardSizes = [58, 66, 74, 82, 90, 105, 125, 150, 185, 225, 270];
      var sizeIndex = 8;
      try{
        var savedSizeIndex = parseInt(localStorage.getItem('ftgHomepageCardSizeV3'), 10);
        if(Number.isInteger(savedSizeIndex) && savedSizeIndex >= 0 && savedSizeIndex < cardSizes.length) sizeIndex = savedSizeIndex;
      }catch(e){}

      function setCardSize(index){
        sizeIndex = Math.max(0, Math.min(cardSizes.length - 1, Number(index)));
        grid.style.setProperty('--ftg-card-size', cardSizes[sizeIndex] + 'px');
        browser.style.setProperty('--ftg-card-size', cardSizes[sizeIndex] + 'px');
        if(sizeSlider) sizeSlider.value = String(sizeIndex);
        if(sizeValue) sizeValue.textContent = (sizeIndex + 1) + ' / ' + cardSizes.length;
        if(sizeDown) sizeDown.disabled = sizeIndex === 0;
        if(sizeUp) sizeUp.disabled = sizeIndex === cardSizes.length - 1;
        try{ localStorage.setItem('ftgHomepageCardSizeV3', String(sizeIndex)); }catch(e){}
      }
      if(sizeSlider) sizeSlider.addEventListener('input', function(){ setCardSize(sizeSlider.value); render(); });
      if(sizeDown) sizeDown.addEventListener('click', function(){ setCardSize(sizeIndex - 1); render(); });
      if(sizeUp) sizeUp.addEventListener('click', function(){ setCardSize(sizeIndex + 1); render(); });
      setCardSize(sizeIndex);

      // Open with the curated Homepage collection order. Shoppers can still
      // choose price or brand sorting from the dropdown.
      sort.value = 'manual';

      var cards = Array.from(grid.querySelectorAll('[data-ftg-product-card]'));
      var homeCards = cards.filter(function(c){ return c.dataset.ftgPool === 'home'; });
      var globalCards = cards.filter(function(c){ return c.dataset.ftgPool === 'global'; });
      var allowedBrandFilters = ['all', 'islander', 'phoibos', 'ratio', 'seiko', 'citizen', 'tissot', 'gucci', 'maserati', 'uboat', 'others', 'designer', 'under-200'];
      var selectedBrand = 'all';
      var searchQuery = '';
      var namedBrands = ['islander', 'phoibos', 'ratio', 'seiko', 'citizen', 'tissot', 'gucci', 'maserati', 'uboat'];
      var brandBackgroundChoices = {};

      function brandFromAddress(){
        var requested = '';
        try{ requested = (new URL(window.location.href).searchParams.get('brand') || '').toLowerCase(); }catch(e){}
        return allowedBrandFilters.indexOf(requested) !== -1 ? requested : 'all';
      }

      function updateActiveBrandTab(){
        tabs.querySelectorAll('[data-brand]').forEach(function(tab){
          var active = tab.dataset.brand === selectedBrand;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-pressed', String(active));
        });
        if(sectionTitle) sectionTitle.textContent = selectedBrand === 'designer' ? 'Designer & Fashion Watches' : 'In Stock Collector Watches';
        if(categoryIntro) categoryIntro.hidden = selectedBrand !== 'designer';
      }

      function updateBrandAddress(){
        try{
          var url = new URL(window.location.href);
          if(selectedBrand === 'all') url.searchParams.delete('brand');
          else url.searchParams.set('brand', selectedBrand);
          window.history.pushState({ftgBrand:selectedBrand}, '', url.pathname + url.search + url.hash);
        }catch(e){}
      }

      selectedBrand = brandFromAddress();
      updateActiveBrandTab();

      function brandText(card){
        return ((card.dataset.brand || '') + ' ' + (card.dataset.title || '')).toLowerCase();
      }
      function normalizedBrandText(card){
        return brandText(card).replace(/[^a-z0-9]+/g, '');
      }
      function matchesBrand(card, brand){
        if(brand === 'uboat') return normalizedBrandText(card).indexOf('uboat') !== -1;
        return brandText(card).indexOf(brand) !== -1;
      }
      function isNamedBrand(card){
        return namedBrands.some(function(brand){ return matchesBrand(card, brand); });
      }
      function isDesigner(card){
        var identity = brandText(card);
        if(identity.indexOf('gucci') !== -1) return false;
        return card.dataset.ftgDesigner === 'true' ||
          identity.indexOf('guess') !== -1 ||
          identity.indexOf('gant') !== -1 ||
          identity.indexOf('versace') !== -1 ||
          identity.indexOf('maserati') !== -1;
      }
      function matchesSearch(card){
        if(!searchQuery) return true;
        var haystack = ((card.dataset.title || '') + ' ' + (card.dataset.brand || '')).toLowerCase();
        var normalizedHaystack = haystack.replace(/[^a-z0-9]+/g, ' ');
        var terms = searchQuery.toLowerCase().trim().split(/\s+/).filter(Boolean);
        return terms.every(function(term){
          var normalizedTerm = term.replace(/[^a-z0-9]+/g, '');
          return haystack.indexOf(term) !== -1 || (normalizedTerm && normalizedHaystack.replace(/\s+/g, '').indexOf(normalizedTerm) !== -1);
        });
      }
      function sortCards(list){
        return list.slice().sort(function(a,b){
          var aPrice = parseInt(a.getAttribute('data-price'), 10);
          var bPrice = parseInt(b.getAttribute('data-price'), 10);
          if(!Number.isFinite(aPrice)) aPrice = 0;
          if(!Number.isFinite(bPrice)) bPrice = 0;
          if(sort.value === 'price-asc'){
            if(aPrice !== bPrice) return aPrice - bPrice;
            return Number(a.dataset.manualOrder || 0) - Number(b.dataset.manualOrder || 0);
          }
          if(sort.value === 'price-desc'){
            if(aPrice !== bPrice) return bPrice - aPrice;
            return Number(a.dataset.manualOrder || 0) - Number(b.dataset.manualOrder || 0);
          }
          if(sort.value === 'brand-asc') return (a.dataset.brand || '').localeCompare(b.dataset.brand || '', undefined, {sensitivity:'base'});
          // Manual mode: keep the carefully arranged Homepage collection first,
          // then append any remaining store products. Duplicate product IDs are
          // removed later, so the Homepage version always wins.
          var ap = a.dataset.ftgPool === 'home' ? 0 : 1;
          var bp = b.dataset.ftgPool === 'home' ? 0 : 1;
          if(ap !== bp) return ap - bp;
          return Number(a.dataset.manualOrder) - Number(b.dataset.manualOrder);
        });
      }

      function updateBrandBackground(visibleCards){
        if(selectedBrand === 'all' || !visibleCards.length){
          browser.classList.remove('has-brand-background');
          browser.style.removeProperty('--ftg-brand-background');
          browser.style.removeProperty('--ftg-brand-background-height');
          browser.removeAttribute('data-active-brand');
          return;
        }

        var cardsWithImages = visibleCards.filter(function(card){
          return card.querySelector('.ftg-card-main-image img');
        });
        if(!cardsWithImages.length){
          browser.classList.remove('has-brand-background');
          browser.style.removeProperty('--ftg-brand-background');
          browser.style.removeProperty('--ftg-brand-background-height');
          browser.removeAttribute('data-active-brand');
          return;
        }

        // Pick a random in-stock watch from the active category whenever it is
        // opened, then keep that backdrop steady while sorting or searching.
        var chosenId = brandBackgroundChoices[selectedBrand];
        var chosenCard = cardsWithImages.find(function(card){
          return (card.dataset.productId || card.href) === chosenId;
        });
        if(!chosenCard){
          chosenCard = cardsWithImages[Math.floor(Math.random() * cardsWithImages.length)];
          brandBackgroundChoices[selectedBrand] = chosenCard.dataset.productId || chosenCard.href;
        }
        var image = chosenCard.querySelector('.ftg-card-main-image img');
        var imageUrl = image.currentSrc || image.src || image.getAttribute('src');
        if(!imageUrl) return;
        imageUrl = imageUrl.replace(/([?&]width=)\d+/i, function(match, prefix){ return prefix + '1800'; });
        browser.style.setProperty('--ftg-brand-background', 'url(' + JSON.stringify(imageUrl) + ')');
        browser.classList.add('has-brand-background');
        browser.setAttribute('data-active-brand', selectedBrand);

        // Measure the rendered grid so the backdrop ends just below row two,
        // regardless of the shopper's selected card size or screen width.
        requestAnimationFrame(function(){
          var browserTop = browser.getBoundingClientRect().top;
          var rowTops = [];
          visibleCards.forEach(function(card){
            var top = Math.round(card.getBoundingClientRect().top);
            if(!rowTops.some(function(rowTop){ return Math.abs(rowTop - top) < 5; })) rowTops.push(top);
          });
          rowTops.sort(function(a,b){ return a-b; });
          var lastIncludedTop = rowTops[Math.min(1, rowTops.length - 1)];
          var panelBottom = visibleCards.reduce(function(bottom, card){
            var rect = card.getBoundingClientRect();
            return rect.top <= lastIncludedTop + 5 ? Math.max(bottom, rect.bottom) : bottom;
          }, browserTop + 520);
          browser.style.setProperty('--ftg-brand-background-height', Math.ceil(panelBottom - browserTop + 22) + 'px');
        });
      }

      function render(){
        cards.forEach(function(card){ card.hidden = true; });
        // Every tab now searches the full in-stock catalog. Homepage collection
        // cards are placed first so your manually arranged landing-page order is
        // preserved, while products not in that collection are appended after it.
        var source = homeCards.concat(globalCards);

        var visibleCards = [];
        var seen = new Set();
        sortCards(source).forEach(function(card){
          var id = card.dataset.productId || card.href;
          if(seen.has(id)) return;
          var show = false;
          // Keep the default storefront collector-focused. Designer/fashion
          // watches remain available in their own tab and direct product URLs.
          if(selectedBrand === 'all') show = !isDesigner(card);
          else if(selectedBrand === 'others') show = !isNamedBrand(card) && !isDesigner(card);
          else if(selectedBrand === 'designer') show = isDesigner(card);
          else if(selectedBrand === 'under-200') show = Number(card.dataset.price || 0) <= 20000 && !isDesigner(card);
          else show = matchesBrand(card, selectedBrand);
          show = show && matchesSearch(card);
          if(show){
            seen.add(id);
            visibleCards.push(card);
          }
        });

        visibleCards.forEach(function(card){
          grid.appendChild(card);
          card.hidden = false;
        });
        updateBrandBackground(visibleCards);
        if(empty) empty.hidden = visibleCards.length !== 0;
        if(searchClear) searchClear.hidden = !searchQuery;
        if(searchStatus){
          if(searchQuery){
            searchStatus.textContent = visibleCards.length + (visibleCards.length === 1 ? ' watch found' : ' watches found') + ' for “' + search.value.trim() + '”';
          } else {
            searchStatus.textContent = '';
          }
        }
      }

      if(search){
        search.addEventListener('input', function(){
          searchQuery = search.value.trim();
          render();
        });
        search.addEventListener('keydown', function(event){
          if(event.key === 'Escape' && search.value){
            search.value = '';
            searchQuery = '';
            render();
          }
        });
      }
      if(searchClear){
        searchClear.addEventListener('click', function(){
          search.value = '';
          searchQuery = '';
          render();
          search.focus();
        });
      }

      tabs.addEventListener('click', function(event){
        var button = event.target.closest('[data-brand]');
        if(!button) return;
        selectedBrand = button.dataset.brand;
        delete brandBackgroundChoices[selectedBrand];
        updateActiveBrandTab();
        updateBrandAddress();
        render();
      });
      window.addEventListener('popstate', function(){
        selectedBrand = brandFromAddress();
        delete brandBackgroundChoices[selectedBrand];
        updateActiveBrandTab();
        render();
      });
      sort.addEventListener('change', render);
      render();
    });
  });
})();

/* === FTG NEWSLETTER POPUP === */
(function(){
  const STORAGE_KEY = 'ftgNewsletterPopupClosed';
  const SUCCESS_KEY = 'ftgNewsletterPopupJoined';

  function ready(fn){
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', fn); }
    else { fn(); }
  }

  ready(function(){
    const popup = document.getElementById('ftg-newsletter-popup');
    if(!popup) return;

    const urlParams = new URLSearchParams(window.location.search);
    const forceShow = urlParams.get('showpopup') === '1' || window.location.hash === '#ftg-newsletter-popup';

    if(window.location.hash === '#contact_form' || urlParams.get('customer_posted') === 'true'){
      try{ localStorage.setItem(SUCCESS_KEY, 'true'); }catch(e){}
    }

    function openPopup(){
      try{
        if(!forceShow && localStorage.getItem(SUCCESS_KEY) === 'true') return;
        const closedAt = Number(localStorage.getItem(STORAGE_KEY) || 0);
        const oneHour = 60 * 60 * 1000;
        if(!forceShow && closedAt && Date.now() - closedAt < oneHour) return;
      }catch(e){}
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden','false');
    }

    function closePopup(){
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden','true');
      try{ localStorage.setItem(STORAGE_KEY, String(Date.now())); }catch(e){}
    }

    // Let first-time visitors understand the store before asking for an email.
    // The popup still opens immediately when explicitly requested by URL.
    setTimeout(openPopup, forceShow ? 200 : 25000);

    document.addEventListener('click', function(e){
      if(e.target.closest('[data-ftg-newsletter-close]')) closePopup();
      if(e.target.closest('[data-ftg-open-newsletter]')){ e.preventDefault(); openPopup(); }
    });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });
  });
})();
/* Populate missing watch dimensions from product descriptions. Metafields always win. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ftg-watch-specs]').forEach(function (specs) {
    var source = specs.querySelector('.ftg-spec-source');
    var value = source ? source.textContent.replace(/\s+/g, ' ') : '';
    var diameter = specs.querySelector('[data-ftg-diameter]');
    var lug = specs.querySelector('[data-ftg-lug-to-lug]');
    var diameterMatch = value.match(/(?:case\s*)?diameter\s*[:\-]?\s*(\d{2}(?:\.\d+)?)\s*mm/i);
    var lugMatch = value.match(/lug[\s-]*to[\s-]*lug\s*[:\-]?\s*(\d{2}(?:\.\d+)?)\s*mm/i);
    if (diameter && diameter.hidden && diameterMatch) { diameter.querySelector('b').textContent = diameterMatch[1] + ' mm'; diameter.hidden = false; }
    if (lug && lug.hidden && lugMatch) { lug.querySelector('b').textContent = lugMatch[1] + ' mm'; lug.hidden = false; }
    if (source) source.remove();
    if (!specs.querySelector('span:not([hidden])')) specs.hidden = true;
  });
});

/* Build the live sold-watch ticker from Flow-managed product metafields. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ftg-sold-ticker]').forEach(function (ticker) {
    var track = ticker.querySelector('[data-ftg-sold-ticker-track]');
    if (!track) return;

    var items = Array.from(track.querySelectorAll('[data-ftg-sold-item]'));
    var cutoff = Date.now() - (120 * 24 * 60 * 60 * 1000);
    items.forEach(function (item) {
      var soldTime = Date.parse(item.getAttribute('data-sold-at') || '');
      if (!Number.isFinite(soldTime) || soldTime < cutoff) item.remove();
    });

    items = Array.from(track.querySelectorAll('[data-ftg-sold-item]'));
    items.sort(function (a, b) {
      return Date.parse(b.getAttribute('data-sold-at')) - Date.parse(a.getAttribute('data-sold-at'));
    });

    var empty = track.querySelector('[data-ftg-sold-ticker-empty]');
    if (!items.length) {
      if (!empty) {
        empty = document.createElement('span');
        empty.className = 'ftg-sold-ticker-empty';
        empty.textContent = 'Recent sales will appear here automatically.';
        track.appendChild(empty);
      }
      ticker.classList.add('is-empty');
      return;
    }

    if (empty) empty.remove();
    items.forEach(function (item) { track.appendChild(item); });
    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      track.appendChild(clone);
    });
    ticker.classList.add('is-ready');
  });
});

/* Persistent Back and Home navigation. Keep Back inside FTG when possible. */
document.addEventListener('DOMContentLoaded', function () {
  var backButton = document.querySelector('[data-ftg-go-back]');
  if (!backButton) return;

  backButton.addEventListener('click', function () {
    var hasSameSiteReferrer = false;
    try {
      hasSameSiteReferrer = Boolean(document.referrer) && new URL(document.referrer).origin === window.location.origin;
    } catch (error) {}

    if (hasSameSiteReferrer && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.assign('/collections/all');
    }
  });
});
